import { render, staticRenderFns } from "./ListReviewCommentTaskDialog.vue?vue&type=template&id=5069e30a&"
import script from "./ListReviewCommentTaskDialog.vue?vue&type=script&lang=js&"
export * from "./ListReviewCommentTaskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports